import React from 'react'; // Import React to create the component
import '../css/HomePage.css';
import Navigationbar from './NavigationBar';
import Footer from './Footer';
import { useState } from 'react';
import ProfileNavBar from './ProfileNavBar';
const HomePage = () => {
    const user = JSON.parse(sessionStorage.getItem('user')); // Retrieve user information from session storage
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [bmi, setBMI] = useState('');
    const [bmiCategory, setBMICategory] = useState('');
    const [healthRisk, setHealthRisk] = useState('');
    const [idealWeight, setIdealWeight] = useState('');
    const [weightStatus, setWeightStatus] = useState('');

    const handleBMI = (event) => {
        event.preventDefault();

        if (weight && height) {
            const heightInMeters = height / 100;  // Convert height from cm to meters
            const calculatedBMI = (weight / (heightInMeters * heightInMeters)).toFixed(2);

            setBMI(calculatedBMI);
            determineBMICategory(calculatedBMI);
            calculateIdealWeight(heightInMeters);
        }
    };

    const determineBMICategory = (bmi) => {
        if (bmi < 18.5) {
            setBMICategory('Underweight');
            setHealthRisk('Malnutrition risk');
            setWeightStatus('Gain Weight');
        } else if (bmi >= 18.5 && bmi < 24.9) {
            setBMICategory('Normal weight');
            setHealthRisk('Low risk');
            setWeightStatus('Maintain Weight');
        } else if (bmi >= 25 && bmi < 29.9) {
            setBMICategory('Overweight');
            setHealthRisk('Enhanced risk');
            setWeightStatus('Lose Weight');
        } else {
            setBMICategory('Obese');
            setHealthRisk('High risk');
            setWeightStatus('Lose Weight');
        }
    };

    const calculateIdealWeight = (heightInMeters) => {
        // Calculate ideal weight using the Devine Formula (for simplicity)
        const ideal = 50 + 2.3 * ((heightInMeters * 100 - 152) / 2.54);
        setIdealWeight(ideal.toFixed(2));
    };
    // JSX to render the About Us page content
    return (
        <div>
            {user ? <ProfileNavBar /> : <Navigationbar />} {/* Renders the navigation bar at the top of the page */}
            <div className='HomePageContent'>
                <h1 className='HomePageHeaders'>Welcome to Fitness Tracker, Your Ultimate Fitness Companion!</h1>
                <p>
                    Jumpstart your fitness journey with Fitness Tracker, the all-in-one platform designed to empower you to reach your health and wellness goals. Whether you're looking to track your daily activities, monitor your nutritional intake, or set and achieve specific fitness milestones, Fitness Tracker provides the tools you need for success.
                </p>
                <div className='HomePageAd'>
                    <video controls autoPlay loop muted>
                        <source src="/images/HomePageAd.mp4" type="video/mp4" />
                    </video>
                </div>
                <br></br>
                <br></br>
                <div className='HomePageFeatures'>
                    <h1 className='HomePageHeaders'>Features at your fingertips:</h1>
                    <ul>
                        <li><strong>Activity Tracking:</strong> Log every step, swim, or cycle and see your progress in real time. Our intuitive interface makes it easy to record workouts and track your performance improvements over time.</li>
                        <br></br>
                        <li><strong>Nutritional Tracking:</strong> Monitor your calorie intake, set fitness goals, and track your progress with our comprehensive nutritional tracking feature. Stay motivated and achieve your health and wellness goals with Fitness Tracker.</li>
                        <br></br>
                        <li><strong>Workout Planning:</strong> Create customized workout plans, set goals, and track your progress with our workout tracking feature. Get motivated and stay motivated on your fitness journey with Fitness Tracker.</li>
                        <br></br>
                        <li><strong>Community Support:</strong> Connect with a supportive community of fitness enthusiasts. Share your achievements, get advice, and support each other on your fitness journey with Fitness Tracker.</li>
                        <br></br>
                        <li><strong>AI Driven Insights:</strong> Receive personalized insights and recommendations based on your data to help you optimize your fitness routine and achieve your goals.</li>
                        <br></br>
                        <li><strong>Secure and Private:</strong> Your data is secure and private. We use advanced encryption and security measures to protect your information and ensure your privacy.</li>
                        <br></br>
                    </ul>
                </div>
                <br></br>
                <div className='HomePageFeatures'>
                    <br></br>
            <h1 className='HomePageHeaders2'>Calculate BMI</h1>
            <form className='bmiform' onSubmit={handleBMI}>
                <label htmlFor="weight">Weight (in kgs)</label>
                <input type="number" id="weight" name="weight" value={weight} onChange={(e) => setWeight(e.target.value)} required />
                
                <label htmlFor="height">Height (in cms)</label>
                <input type="number" id="height" name="height" value={height} onChange={(e) => setHeight(e.target.value)} required />
                
                <br></br>
                <button type="submit" className='loginbutton'>Calculate BMI</button>
                <br></br>
                <br></br>
            </form>
            {bmi && (
                <div className='bmiresult'>
                    <h3 className='HomePageHeaders2'>Your BMI is: {bmi}</h3>
                    <h3 className='HomePageHeaders2'>Your BMI Category is: {bmiCategory}</h3>
                    <h3 className='HomePageHeaders2'>Your BMI Health is: {healthRisk}</h3>
                    <h3 className='HomePageHeaders2'>Your Ideal Weight is: {idealWeight} kg</h3>
                    <h3 className='HomePageHeaders2'>Your Weight Status is: {weightStatus}</h3>
                </div>
            )}
        </div>
                </div>
                <Footer /> {/* Renders the footer at the bottom of the page */}
            </div>
            );
};

            export default HomePage; // Export the AboutUs component so it can be used in other parts of the app
